module.exports = __webpack_public_path__ + "img/avatar-smoked.54f29438.png";